import React from 'react';

import { AsaphAvatar } from '@/components/shared/Avatar';
import { NotificationBadge } from '@/components/shared/NotificationBadge';
import { UserAvatar } from '@/components/UserAvatar';
import { useAuth } from '@/providers/AuthProvider';
import { useTeamActionSubscription } from '@/providers/TeamActionSubscription';
import { useTeam } from '@/providers/TeamProvider';
import constants from '@/theme/exportedVariables.module.scss';
import { useMediaQuery } from '@material-ui/core';
import { pathOr } from 'ramda';

import styles from './DashboardHeader.module.scss';

interface IProps {
	onProfileClick: () => void;
}

export const DashboardHeader: React.FC<IProps> = ({ onProfileClick }) => {
	const { user } = useAuth();
	const { team } = useTeam();
	const { isConnected } = useTeamActionSubscription();

	const name = getFirstName(user.displayName ?? '');

	return (
		<div className={styles['user-details']}>
			<div className={styles['profile']} onClick={onProfileClick}>
				<div className={styles['image']}>
					<UserAvatar
						userId={user.id}
						size="x-small"
						className={styles['avatar']}
						notificationSize="small"
					/>
				</div>
				<div>
					<div className={styles['name']}>
						<span>{name}</span>
					</div>
					<div className={styles['team']}>
						<span>{team.name}</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export function getFirstName(name: string): string {
	const splitName = name.split(' ');
	return pathOr('', [0], splitName);
}
